import { Application } from "./application";
import { SystemField } from "./system-field";

export class User extends SystemField{ 
	title?:string;
	phone?:string;
	email?:string;
	username?:string;
	district?:string;
	commune?:string;
	country?:string;
	city?:string;
	password?:string;
	api_token?:string;
	photo?:string;
	is_active?:number;
	is_locked?:number;
	currency_code?:string;
	user_type?:string;
	is_admin?:number;
	status?:string;
	user_roles_id?:string; 
	user_code?:string;
	company_id?:string;
	lock_reason?:string;
	user_permission_id?:string;
	record_type_id?:string;
	profile_ids?:string;
	alias?:string;
	score?:number;
	timezone?:string;


	// Formula Fields
	photo_file?:File;
	photo_preview?:string;
	record_type_name?: string;
	user_roles?: string; 
	langs?: any;

	//relationship
	applications?:Application[];
	
	new_password?:string;
	profiles?:any;
}

export class UserTranslate extends SystemField{ 
	
	users_id?:string;
	firstname?:string;
	lastname?:string;
	nickname?:string;
	address_line?:string;
	lang_code?:string;
}